import _ from "lodash";
import { InstalledBaseNodeTypeKey } from "../codegen/graphql";

export interface ClosestPathNode {
  title: string;
  nodeTypeKey: string;
}

// Returns the closest ancestor of the given node type for a row carrying
// `assetLocation.installedBaseNode.pathNodes` (ordered root → leaf, parents
// only), so the last match is closest to the asset — this satisfies the
// Tool > Chamber > Asset constellation and the fallback of showing the closest
// present Tool/Chamber when the full hierarchy is missing. Keeps the node type
// so callers can render the matching installed base icon next to the title.
export const getClosestPathNodeByKey = (
  row: any,
  key: InstalledBaseNodeTypeKey
): ClosestPathNode | null => {
  const pathNodes = _.get(row, "assetLocation.installedBaseNode.pathNodes") ?? [];
  const matches = pathNodes.filter((n: any) => _.get(n, "nodeType.key") === key);
  if (!matches.length) return null;
  return { title: matches[matches.length - 1].title ?? "", nodeTypeKey: key };
};
